
// This to use the prepackaed, unmodified version
// window.ClassicEditor = require('@ckeditor/ckeditor5-build-classic');

// This to try the custom version

import { ClassicEditor } from '@ckeditor/ckeditor5-editor-classic';
import { Alignment } from '@ckeditor/ckeditor5-alignment';
import { Autoformat } from '@ckeditor/ckeditor5-autoformat';
import { BlockQuote } from '@ckeditor/ckeditor5-block-quote';
import { Bold } from '@ckeditor/ckeditor5-basic-styles';
import { Essentials } from '@ckeditor/ckeditor5-essentials';
import { GeneralHtmlSupport } from '@ckeditor/ckeditor5-html-support';
import { Heading } from '@ckeditor/ckeditor5-heading';
import { HorizontalLine } from '@ckeditor/ckeditor5-horizontal-line';
import { Image } from '@ckeditor/ckeditor5-image';
import { ImageCaption } from '@ckeditor/ckeditor5-image';
import { ImageResize } from '@ckeditor/ckeditor5-image';
import { ImageStyle } from '@ckeditor/ckeditor5-image';
import { ImageToolbar } from '@ckeditor/ckeditor5-image';
import { Italic } from '@ckeditor/ckeditor5-basic-styles';
import { Link } from '@ckeditor/ckeditor5-link';
import { List } from '@ckeditor/ckeditor5-list';
import { ListProperties } from '@ckeditor/ckeditor5-list';
import { MediaEmbed } from '@ckeditor/ckeditor5-media-embed';
import { Paragraph } from '@ckeditor/ckeditor5-paragraph';
import { RemoveFormat } from '@ckeditor/ckeditor5-remove-format';
import { SourceEditing } from '@ckeditor/ckeditor5-source-editing';
import { Strikethrough } from '@ckeditor/ckeditor5-basic-styles';
import { Table } from '@ckeditor/ckeditor5-table';
import { TableToolbar } from '@ckeditor/ckeditor5-table';
import { TableProperties } from '@ckeditor/ckeditor5-table';
import { TableCellProperties } from '@ckeditor/ckeditor5-table';
import { WordCount } from '@ckeditor/ckeditor5-word-count';

// import {
//     ClassicEditor,
//     Alignment, Autoformat, BlockQuote, Bold, Essentials, GeneralHtmlSupport,
//     Heading, HorizontalLine, Image, ImageCaption, ImageResize, ImageStyle, ImageToolbar,
//     Italic, Link, List, ListProperties, MediaEmbed, Paragraph, RemoveFormat, SourceEditing,
//     Strikethrough, Table, TableToolbar, TableProperties, TableCellProperties, WordCount
// } from 'ckeditor5';

// import CKEditorInspector from '@ckeditor/ckeditor5-inspector';

import MediaLibraryImage from '../plugins/ckeditor-custom/media-library-image/media-library-image';
import MediaLibraryFileLink from '../plugins/ckeditor-custom/media-library-file/media-library-file-link';
import MediaLibraryVideo from '../plugins/ckeditor-custom/media-library-video/media-library-video';

import 'ckeditor5/ckeditor5.css';

initCkEditor();

function initCkEditor() {
    if (document.querySelector('textarea.wysiwyg')) {
        $('textarea.wysiwyg').each(function() {
            initSingleCkEditor(this);
        });
    }

    if (document.querySelector('textarea.wysiwygSimple')) {
        $('textarea.wysiwygSimple').each(function () {
            initSingleSimpleCkEditor(this);
        });
    }
}

function initSingleCkEditor(el) {
    ClassicEditor.create(el, {
        licenseKey: 'GPL',
        plugins: [
            Alignment,
            Autoformat,
            BlockQuote,
            Bold,
            Essentials,
            GeneralHtmlSupport,
            Heading,
            HorizontalLine,
            Image,
            ImageCaption,
            ImageResize,
            ImageStyle,
            ImageToolbar,
            Italic,
            Link,
            List,
            ListProperties,
            MediaEmbed,
            Paragraph,
            RemoveFormat,
            SourceEditing,
            Strikethrough,
            Table,
            TableToolbar,
            TableProperties,
            TableCellProperties,
            WordCount,
            MediaLibraryImage,
            MediaLibraryFileLink,
            MediaLibraryVideo,
        ],
        alignment: {
            options: ['left', 'center', 'right']
        },
        heading: {
            options: [
                {model: 'paragraph', title: 'Paragraph Text', class: 'ck-heading_paragraph'},
                {model: 'heading2', view: 'h2', title: 'Heading 2', class: 'ck-heading_heading2'},
                {model: 'heading3', view: 'h3', title: 'Heading 3', class: 'ck-heading_heading3'},
                {model: 'heading4', view: 'h4', title: 'Heading 4', class: 'ck-heading_heading4'},
                {model: 'heading5', view: 'h5', title: 'Heading 5', class: 'ck-heading_heading5'},
                {model: 'heading6', view: 'h6', title: 'Heading 6', class: 'ck-heading_heading6'}
            ]
        },
        image: {
            toolbar: [
                //'imageStyle:full',
                'imageStyle:inline',
                'imageStyle:block',
                'imageStyle:side',
                'imageStyle:alignLeft',
                'imageStyle:alignRight',
                'imageStyle:alignBlockLeft',
                'imageStyle:alignBlockRight',
                'imageStyle:alignCenter',
                '|',
                'imageResize:original',
                'imageResize:25',
                'imageResize:50',
                'imageResize:75',
                '|',
                'toggleImageCaption',
                'imageTextAlternative'
            ],
            resizeUnit: '%',
            resizeOptions: [
                {
                    name: 'imageResize:original',
                    value: null,
                    icon: 'original'
                },
                {
                    name: 'imageResize:25',
                    value: '25',
                    icon: 'small'
                },
                {
                    name: 'imageResize:50',
                    value: '50',
                    icon: 'medium'
                },
                {
                    name: 'imageResize:75',
                    value: '75',
                    icon: 'large'
                }
            ]
        },
        link: {
            decorators: {
                openInNewTab: {
                    mode: 'manual',
                    label: 'Open in a new tab',
                    defaultValue: true,			// This option will be selected by default.
                    attributes: {
                        target: '_blank',
                        rel: 'noopener noreferrer'
                    }
                }
            }
        },
        mediaEmbed: {
            previewsInData: true,
            removeProviders: ['instagram', 'twitter', 'googleMaps', 'flickr', 'facebook']
        },
        toolbar: {
            items: [
                'heading',
                '|',
                'bold',
                'italic',
                'strikethrough',
                'blockQuote',
                '|',
                'removeFormat',
                '|',
                'alignment',
                '|',
                'bulletedList',
                'numberedList',
                '|',
                'insertTable',
                'horizontalLine',
                'link',
                '|',
                'mediaLibraryImage',
                'mediaLibraryFileLink',
                'mediaLibraryVideo',
                'mediaEmbed',
                '|',
                'undo',
                'redo',
                '|',
                'sourceEditing'
            ]
        },
        table: {
            contentToolbar: [
                'tableColumn', 'tableRow', 'mergeTableCells',
                'tableProperties', 'tableCellProperties'
            ],
            // Configuration of the TableProperties plugin.
            tableProperties: {
                // ...
            },
            // Configuration of the TableCellProperties plugin.
            tableCellProperties: {
                // ...
            }
        },
        language: 'en',
        htmlSupport: {
            allow: [
                {
                    name: 'div',
                    classes: true,
                },
                {
                    name: 'span',
                    classes: true,
                }
            ]
        },
    })
        // .then( editor => {
        //     CKEditorInspector.attach( editor );
        // })
        .catch(error => {
            console.error(error);
        });
}

function initSingleSimpleCkEditor(el) {
    ClassicEditor.create(el, {
        licenseKey: 'GPL',
        plugins: [
            Alignment,
            Autoformat,
            BlockQuote,
            Bold,
            Essentials,
            Heading,
            Italic,
            Link,
            List,
            ListProperties,
            Paragraph,
            RemoveFormat,
            SourceEditing,
            Strikethrough
        ],
        alignment: {
            options: ['left', 'center', 'right']
        },
        heading: {
            options: [
                {model: 'paragraph', title: 'Paragraph Text', class: 'ck-heading_paragraph'},
                {model: 'heading2', view: 'h2', title: 'Heading 1', class: 'ck-heading_heading2'},
                {model: 'heading3', view: 'h3', title: 'Heading 2', class: 'ck-heading_heading3'},
                {model: 'heading4', view: 'h4', title: 'Heading 3', class: 'ck-heading_heading4'}
            ]
        },
        link: {
            decorators: {
                openInNewTab: {
                    mode: 'manual',
                    label: 'Open in a new tab',
                    defaultValue: true,			// This option will be selected by default.
                    attributes: {
                        target: '_blank',
                        rel: 'noopener noreferrer'
                    }
                }
            }
        },
        toolbar: {
            items: [
                'heading',
                '|',
                'bold',
                'italic',
                'strikethrough',
                'blockQuote',
                '|',
                'removeFormat',
                '|',
                'alignment',
                '|',
                'bulletedList',
                'numberedList',
                '|',
                'link',
                '|',
                'undo',
                'redo',
                '|',
                'sourceEditing'
            ]
        },
        language: 'en'
    })
        .catch(error => {
            console.error(error);
        });
}

function destroyCkEditor() {

    $('.ck-editor__editable').each(function () {
        this.ckeditorInstance.destroy()
    });

}

window.initCkEditor = initCkEditor;
window.initSingleCkEditor = initSingleCkEditor;
window.initSingleSimpleCkEditor = initSingleSimpleCkEditor;
window.destroyCkEditor = destroyCkEditor;
